import { useAuth0 } from '@auth0/auth0-react';
import { ReactComponent as PlusIcon } from 'assets/icons/plus.svg';
import DeleteSvgComponent from "assets/icons/svg/DeleteSvg/Delete";
import { Loader, MyCheckbox } from 'components';
import Button from 'components/button/Button';
import AlertDialog from "components/Dialog";
import MyModal from "components/MyModal";
import FinanceService from 'Lib/API/Finance';
import React, { useEffect, useState } from 'react';
import { toastr } from 'react-redux-toastr';
import { AddCard } from './AddCard';
import { CreditCardMethodButton, CreditCardMethodContainer, CreditCardMethodContent, CreditCardMethodHeader, CreditCardMethodItem, CreditCardMethodList, CreditCardMethodTitle } from './Theme';
const CreditCardMethod = ({
  getUserAccount,
}) => {
  const { getAccessTokenSilently } = useAuth0();

  const accountId = localStorage.getItem("accountID");

  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [defaultCard, setDefaultCard] = useState(null);
  const [setDefaultLoading, setSetDefaultLoading] = useState(false);
  const [openAlert, setOpenAlert] = useState(false);
  const [creditId, setCreditId] = useState(null);
  const [openModal, setOpenModal] = useState(false);


  async function getCreditCards() {
    const updatedAccountId = accountId || await getUserAccount();
    const token = await getAccessTokenSilently();
    setLoading(true);
    await FinanceService.getCreditCardsByAccountId(token, updatedAccountId)
      .then((res) => {
        if (res) {
          setList(res?.card?.data);
          const findDefaultCard = res?.card?.data?.find((card) => card?.is_default);
          if (findDefaultCard) {
            setDefaultCard(findDefaultCard?.id); 
          } else if (res?.card?.data?.length === 1) {
            handleDefaultCardChange(res?.card?.data[0]?.id);
          }
        }
      })
      .catch((err) => {
        toastr.error('Error', err?.data?.message);
      })
      .finally(() => {
        setLoading(false);
      })
  }



  const handleSetDefaultCard = async (cardId) => {
    const token = await getAccessTokenSilently();
    const data = {
      accountId,
      cardId,
    };
    setSetDefaultLoading(true);
    await FinanceService.setDefaultCreditCard(data, token)
      .then((res) => {
        toastr.success("Success", "Default card set successfully");

      })
      .catch((err) => {
        toastr.error("Error", err?.data?.message || "Something went wrong");
      })
      .finally(() => {
        const timeOut = setTimeout(() => {
          setSetDefaultLoading(false);
        }, 2000);
        return () => {
          clearTimeout(timeOut);
        };
      });

  };
  useEffect(() => {
    getCreditCards();
  }, []);


  const handleDefaultCardChange = (cardId) => {
    setDefaultCard(cardId);
    handleSetDefaultCard(cardId)
  };


  const openConfirmDialog = (id) => {
    setCreditId(id);
    setOpenAlert(true);
  };


  const closeConfirmDialog = () => {
    setOpenAlert(false);
    setCreditId(null);
  };


  const handleDelete = async (cardID) => {
    const token = await getAccessTokenSilently();
    FinanceService.deleteCreditCard(token, cardID, accountId)
      .then((res) => {
        if (res?.card?.messages?.resultCode == "Ok") {
          toastr.success("Success", "Card has been delete successfully ");
        }
        getCreditCards();
      })
      .catch((err) => {
        console.log(err, "response");
        toastr.error('Error', err?.data?.message);
      }).finally(() => {
        closeConfirmDialog();
      });
  };

  return (
    <>
      <CreditCardMethodContainer>
        <CreditCardMethodHeader>
          <CreditCardMethodTitle>Credit Card</CreditCardMethodTitle>
          <Button
            variant="primary"
            size="md"
            onClick={() => setOpenModal(true)}
            style={{
              minWidth: 165,
            }}
          >
            <PlusIcon />
            <span>Add New Card</span>
          </Button>
        </CreditCardMethodHeader>
        <CreditCardMethodContent>

          {loading ? (
            <Loader />
          ) : list?.length > 0 ? list?.map((card) => (
            <CreditCardMethodList key={card?.id} className="credit-card">
              <CreditCardMethodItem>
                {`${card.country ? card.country : ""} ${card.brand ? card.brand : ""} (${card.last4 ? card.last4 : ""
                  }), Exp: ${card.exp_month}/${card.exp_year}`}
                <CreditCardMethodButton
                  onClick={() => openConfirmDialog(card?.id)}
                >
                  <DeleteSvgComponent
                    color={"gray"}
                  />
                </CreditCardMethodButton>
                <div
                  style={setDefaultLoading ? {
                    pointerEvents: "none",
                    opacity: 0.7
                  } : {}}
                >
                  <MyCheckbox
                    title={"Set as default"}
                    handlechange={(e) => {
                      handleDefaultCardChange(card?.id);
                    }}
                    checked={defaultCard === card?.id}
                  />
                </div>

              </CreditCardMethodItem>
            </CreditCardMethodList>
          )) : (
            <h1 className="no-cards">NO CARDS</h1>
          )}
        </CreditCardMethodContent>
      </CreditCardMethodContainer>

      <AlertDialog
        open={openAlert}
        handleClose={() => {
          closeConfirmDialog();
        }}
        onDecline={() => {
          setOpenAlert(false);
        }}
        onAccept={() => {
          handleDelete(creditId);
        }}
        content={"Are you sure you want to delete this credit card?"}
        contentStyle={{
          fontSize: "18px",
        }}
      />
      <MyModal
        className="add-card-modal"
        open={openModal}
        onClose={() => setOpenModal(false)}
      >
        <AddCard
          closeModal={() => setOpenModal(false)}
          refetchAchCards={getCreditCards}

        />
      </MyModal>
    </>
  )
}

export default CreditCardMethod